<div class="fixed inset-0 z-50 m-auto flex items-center justify-center overflow-hidden bg-[#000000cc] p-6 backdrop-blur-md">
  <div class="relative w-[700px] transform rounded-md bg-white text-left transition-all dark:bg-bodyblack">
    <slot name="header">
      <div class="flex w-full items-center justify-between bg-blue-500 p-4 text-white">
        <h1 class="select-none text-xl font-medium">Modal Header</h1>
        <i class="fa-solid fa-xmark fa-lg cursor-pointer" />
      </div>
    </slot>

    <slot name="content">
      <div class="select-none p-4">Modal Content</div>
    </slot>

    <slot name="footer">
      <div class="gap-3 bg-white p-4 mobile:gap-0 sm:flex sm:flex-row-reverse">
        <button type="button" class="inline-flex w-full justify-center rounded-full border border-transparent bg-blue-500 px-3 py-1.5 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 sm:ml-3 sm:w-auto sm:text-sm">Close</button>
      </div>
    </slot>
  </div>
</div>
